import type { App } from 'vue'

// 需要全局引入一些组件，如ElScrollbar，不然一些下拉项样式有问题
import {
  ElLoading,
  ElScrollbar,
  ElInput,
  ElForm,
  ElFormItem,
  ElButton,
  ElCol,
  ElRow,
  ElText,
  ElCascader,
  ElSelect,
  ElTable,
  ElTableColumn,
  ElOption,
  ElIcon,
  ElDialog,
  ElUpload,
  ElPagination,
  ElDivider,
  ElTree,
  ElImage,
  ElSpace,
  ElTimePicker,
  ElCheckbox,
  ElCheckboxButton,
  ElTabs,
  ElTabPane,
  ElRadio,
  ElRadioGroup,
  ElBadge,
  ElDescriptions,
  ElDescriptionsItem
} from 'element-plus'

const plugins = [ElLoading]

const components = [
  ElImage,
  ElButton,
  ElSpace,
  ElScrollbar,
  ElDivider,
  ElPagination,
  ElIcon,
  ElDialog,
  ElUpload,
  ElInput,
  ElForm,
  ElFormItem,
  ElCol,
  ElTable,
  ElTableColumn,
  ElRow,
  ElTree,
  ElText,
  ElCascader,
  ElOption,
  ElSelect,
  ElTimePicker,
  ElCheckbox,
  ElCheckboxButton,
  ElTabs,
  ElTabPane,
  ElRadio,
  ElRadioGroup,
  ElBadge,
  ElDescriptions,
  ElDescriptionsItem
]

export const setupElementPlus = (app: App<Element>) => {
  plugins.forEach((plugin) => {
    app.use(plugin)
  })

  // 为了开发环境启动更快，一次性引入所有样式
  if (import.meta.env.VITE_USE_ALL_ELEMENT_PLUS_STYLE === 'true') {
    import('element-plus/dist/index.css')
    return
  }

  components.forEach((component) => {
    app.component(component.name!, component)
  })
}
